import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';
import { DEFAULT_MIN_BET_AMOUNT } from '@root/constants';
import type { RootState } from '@root/store/store';

export const BET_VALUES_SLICE_KEY = 'betValues';

export interface BetValuesSliceState {
  values: number[];
  currencyCode: string;
  currentBetAmount: number;
}

export const initialState: BetValuesSliceState = {
  values: [10, 20, 30, 50, 100, 500, 1000],
  currencyCode: '',
  currentBetAmount: DEFAULT_MIN_BET_AMOUNT,
};

const betValuesSlice = createSlice({
  name: BET_VALUES_SLICE_KEY,
  initialState,
  reducers: {
    setBetValue: (
      state,
      action: PayloadAction<{ index: number; value: number }>
    ) => {
      const { index, value } = action.payload;
      if (index >= 0 && index < state.values.length) {
        state.values[index] = value;
      }
    },
    setBetValues: (state, action: PayloadAction<number[]>) => {
      state.values = action.payload;
    },
    setCurrentBetAmount: (state, action: PayloadAction<number>) => {
      state.currentBetAmount = action.payload;
    },
    incrementBetAmount: (state, action: PayloadAction<number>) => {
      const step = action.payload;
      state.currentBetAmount += step;
    },
    decrementBetAmount: (state, action: PayloadAction<number>) => {
      const step = action.payload;
      const newAmount = state.currentBetAmount - step;
      state.currentBetAmount = Math.max(newAmount, step);
    },
    setCurrencyCode: (state, action: PayloadAction<string>) => {
      state.currencyCode = action.payload;
    },
  },
});

const betValuesReducer = betValuesSlice.reducer as Reducer;

export default betValuesReducer;

export const betValuesSelector = (state: RootState): BetValuesSliceState =>
  state.betValues;

export const betValuesActions = betValuesSlice.actions;
